/**
 * The path prefix the guest app runs under: `/t` (temporary-event flow), `/p` (permanent-event flow),
 * or '' for an old bare link it could not settle, which then runs exactly as that host did before.
 * Set once by main.tsx, before a flow loads; read by the flows' routers and by the two places that
 * read the address directly.
 */
let base = ''

export function setGuestBase(prefix: string): void {
  base = prefix
}

export function guestBase(): string {
  return base
}

/** The path inside the flow: `pathname` without the prefix. */
export function flowPath(pathname: string = window.location.pathname): string {
  if (!base) return pathname
  if (pathname === base) return '/'
  return pathname.startsWith(base + '/') ? pathname.slice(base.length) : pathname
}
